import { Badge, Icon, Text, VStack } from '@chakra-ui/react';
import { PiToiletBold } from 'react-icons/pi';

import { JournalEntryCard } from '../JournalEntryCard/JournalEntryCard';
import { StoolJournalEntry } from '../types';

export interface StoolEntryCardProps {
  entry: StoolJournalEntry;
}

/**
 * Displays a stool journal entry with Bristol Scale value and comments.
 */
export const StoolEntryCard: React.FC<StoolEntryCardProps> = ({ entry }) => {
  const hasBristolScale =
    entry.bristolScale !== null && entry.bristolScale !== undefined;

  const getBristolScaleColor = (scale?: number | null) => {
    if (!scale) return 'gray';
    if (scale <= 2) return 'red';
    if (scale >= 3 && scale <= 5) return 'green';
    return 'orange';
  };

  const getBristolScaleLabel = (scale?: number | null) => {
    if (!scale) return 'Not specified';
    return `Type ${scale}`;
  };

  return (
    <JournalEntryCard
      entryId={entry.id}
      icon={<Icon as={PiToiletBold} color="text.muted" boxSize={5} />}
      title={
        <Text fontSize="sm" fontWeight={600} color="text.default">
          Stool
        </Text>
      }
      time={entry.createdAt}
      timezone={entry.timezone}
      comments={entry.comments}
    >
      {({ isExpanded: expanded }) => (
        <VStack align="stretch" spacing={2}>
          {/* Bristol Scale */}
          {hasBristolScale && (
            <Badge
              colorScheme={getBristolScaleColor(entry.bristolScale)}
              fontSize="sm"
              alignSelf="flex-start"
              data-testid={`bristol-scale-${entry.bristolScale}`}
            >
              Bristol {getBristolScaleLabel(entry.bristolScale)}
            </Badge>
          )}

          {/* Description */}
          {expanded && entry.description && (
            <Text fontSize="sm" color="text.default">
              {entry.description}
            </Text>
          )}
        </VStack>
      )}
    </JournalEntryCard>
  );
};

StoolEntryCard.displayName = 'StoolEntryCard';
